import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import services from "config/services";
import { Link } from "react-router-dom";

export default function ServicesLinks() {
  return (
    <MKBox flex={1} minWidth={180}>
      <MKTypography variant="h6" fontWeight="bold" mb={0.5} ml={1}>
        Services
      </MKTypography>
      {services.map((service, i) => (
        <MKTypography key={i} variant="body2" mb={0.5}>
          <Link to="/contact" style={{ textDecoration: "none", color: "inherit" }}>
            {service}
          </Link>
        </MKTypography>
      ))}
    </MKBox>
  );
}
